import { createWrapper } from 'src/careflow/ph-core/fhir-client/fhir-react/base';

export const DocumentReferenceWrapper = createWrapper('DocumentReference', () => ({}));
export type WrappedDocumentReference = ReturnType<typeof DocumentReferenceWrapper>;
